import React, { useState, useRef } from 'react';

import './avatar.scss';
import { ProfileQL } from '../../models/Profile';
import { uploadLogo } from '../../services/fiscalpopApi';

interface ProfileMenuProps {
    currentUser: ProfileQL;
    absolute?: true
}

function ProfileAvatar({ currentUser, absolute }: ProfileMenuProps) {
    const inputFileRef = useRef<HTMLInputElement>(null);

    const [newUrl, setNewUrl] = useState('');
    const [logoFileBase, setLogoFileBase] = useState<string | ArrayBuffer>('');

    const fiscalpopProfile = currentUser.fiscalpopProfile;
    //const randQuery = `?i=${Math.random().toString(32).split('.')[1]}`
    const randQuery = ``
    const clientLogo = newUrl || (!!fiscalpopProfile && fiscalpopProfile.logoUrl ? fiscalpopProfile.logoUrl : null);
    const _assignedLogo = !logoFileBase ? clientLogo : logoFileBase;
    const assignedLogo = logoFileBase ? logoFileBase : (_assignedLogo ? `${_assignedLogo}${randQuery}` : '');

    const getBase64 = (file: File): Promise<string | ArrayBuffer> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    const handleLogoFile = (file: File) => {
        console.log('Handling logo file: ', file);
        getBase64(file)
            .then(base => {
                setLogoFileBase(base);
                submitLogoFile(file);
            })
    }

    const submitLogoFile = (file: File) => {
        console.log('Submitting logoFile: ', file);
        if (!file) {
            return;
        }
        console.log('AuthToken: ', currentUser.professionalProfile.authToken);
        const extension = file.type.split('/')[1];
        uploadLogo(currentUser.professionalProfile.authToken, file, extension)
            .then((body) => {
                const ranString = Math.random().toString(32).substring(2);
                setNewUrl(`${body.logoUrl}?id=${ranString}`);
                setLogoFileBase(null);
                console.log('Logo uploaded: ', body);
            })
            .catch(err => {
                console.error('Error uploading Logo: ', err);
            });
    }

    const selectFileToUpload = () => {
        inputFileRef.current.click();
    }

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleLogoFile(event.target.files[0]);
    }
    return (
        <div id="_Avatar" className={`${!!absolute ? 'absolute' : ''}`}>
            <div className="logoWrap">
                <input type="file"
                    ref={inputFileRef}
                    //accept={props.accept}
                    onChange={handleInputChange} />
            </div>
            {
                assignedLogo ?
                    <img src={assignedLogo as string} alt="Perfil usuario" onClick={selectFileToUpload} />
                    :
                    <div className="_isEmpty" onClick={selectFileToUpload}>
                        {
                            /*
                        <span>
                            {currentUser.professionalProfile.companyName.substring(0, 2).toUpperCase()}
                        </span>
                            */
                        }
                        <div className='_emptyChangePicture'>
                            <span className="material-icons">
                                photo_camera
                            </span>
                        </div>
                    </div>
            }
        </div>
    )
}

export default ProfileAvatar;

